// ** WARNING ** - Autogenerated file
import { ReceptorRecord, RECEPTOR_TYPE } from '@trustero/trustero-api-web/lib/agent/receptor_pb'
import { SelectItem } from 'src/components/Reusable/SelectDropdown/SelectDropdown.constants'

            import React from 'react'
            import * as logos from '../components/Icons/Dependencies'
            

export type FieldDef = {
  display: string
  placeholder: string
  field: string
  input_type?: string
  options?: SelectItem[]
  evidence_caption?: string
  service_model_id?: string
  method?: string
}

export type SectionDef = {
  title: string
  description: string
  fields: FieldDef[]
}

export type MethodDef = {
    display?: string
    value: string
    }

export type Receptor = ReceptorRecord.AsObject & {
  name: string
  content: string
  field_template?: FieldDef[]
  service_ids: string[]
  control_ids: string[]
  logo: (
    props: React.DetailedHTMLProps<
      React.ImgHTMLAttributes<HTMLImageElement>,
      HTMLImageElement
    >,
  ) => JSX.Element
  category: string
  config_template?: SectionDef[]
  methods?: MethodDef[]
  type: RECEPTOR_TYPE
}

const DATA:Receptor[] = [

        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-aws",
name: "AWS Receptor",
content: "<p>Trustero supports <a href=\"https://support.trustero.com/knowledge/aws-receptor-authentication-options\" target=\"_blank\" rel=\"noopener noreferrer\">multiple</a> ways to configure how the AWS Receptor authenticates to AWS. Please follow the instructions below to provide the necessary credentials.</p>\n<p><strong>Instructions:</strong></p>\n<p>Method 1: <strong>Assume Role</strong>  </p>\n<ol>\n<li>Create the IAM Role: create the <code>Trustero-CrossAccountRole</code> in a <a href=\"https://support.trustero.com/knowledge/aws-receptor-assume-role-single-aws-account-instructions\" target=\"_blank\" rel=\"noopener noreferrer\">single AWS account</a> or in <a href=\"https://support.trustero.com/knowledge/aws-receptor-assume-role-multiple-aws-accounts-instructions\" target=\"_blank\" rel=\"noopener noreferrer\">multiple AWS accounts</a>.</li>\n<li>Provide the credentials: enter the <code>Account ID</code> and <code>External ID</code> in the <code>Assume Role</code> tab below.</li>\n</ol>\n<p>Method 2: <strong>IAM User</strong>  </p>\n<ol>\n<li>Create the user: create the <code>trustero-api-user</code> in a <a href=\"https://support.trustero.com/knowledge/aws-receptor-iam-user-single-aws-account-instructions\" target=\"_blank\" rel=\"noopener noreferrer\">single AWS account</a> or in <a href=\"https://support.trustero.com/knowledge/aws-receptor-iam-user-multiple-aws-accounts-instructions\" target=\"_blank\" rel=\"noopener noreferrer\">multiple AWS accounts</a>.</li>\n<li>Provide the credentials: enter the <code>trustero-api-user</code> <code>Access key ID</code> and <code>Secret access key</code> in the <code>IAM User</code> tab below.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs4", "trs5", "trs6", "trs7", "trs8", "trs9", "trs10", "trs11", "trs12", "trs13", "trs14", "trs82", "trs83", "trs84", "trs85", "trs100", "trs103", "trs114", "trs115", "trs116", "trs119", "trs120", "trs231"],
control_ids: ["trc12", "trc14", "trc22", "trc23", "trc24", "trc26", "trc29", "trc30", "trc37", "trc38", "trc39", "trc40", "trc43", "trc61", "trc63", "trc64", "trc65", "trc66", "trc67", "trc68", "trc69", "trc72", "trc85", "trc86", "trc102", "trc228", "trc1025", "trc1031", "trc1033", "trc1037", "trc1039", "trc1083", "trc1086", "trc1096", "trc1097", "trc1103", "trc1105", "trc1109", "trc1110", "trc1113", "trc4004", "AM01", "trc4010", "BC04", "trc4011", "BC03", "trc4012", "BC02", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4024", "IP03", "trc4049", "NS02", "trc4051", "NS04", "trc4071", "SC01", "trc4072", "SC02", "trc4073", "SC03", "trc4074", "SC04", "trc4081", "SD05", "trc4091", "IM02", "trc4092", "IM03", "trc4095", "IM06", "trc4106", "VM02"],
logo: logos.AWS,
category: "Cloud Provider",
type: 0,
field_template: [
    {
        "display": "Access key ID",
        "placeholder": "ID",
        "field": "Akid",
        "method": "iam_user"
    },
    {
        "display": "Secret access key",
        "placeholder": "Secret access key",
        "field": "Skey",
        "method": "iam_user",
        "input_type": "password"
    },
    {
        "display": "AWS Account ID",
        "placeholder": "Account ID",
        "field": "AccountId",
        "method": "assume_role"
    },
    {
        "display": "External ID",
        "placeholder": "External ID",
        "field": "ExternalId",
        "method": "assume_role",
        "input_type": "password"
    }
],
methods: [
    {
        "display": "Assume Role",
        "value": "assume_role"
    },
    {
        "display": "IAM User",
        "value": "iam_user"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-gsuite",
name: "Google Workspace Receptor",
content: "<p>Please use the same credentials for Google Cloud Platform and Google Workspace</p>\n<p>The Google Workspace receptor scans settings under your organization's domain to<br />\ngather as much evidence of SOC2 compliance as possible.</p>\n<p>To set up domain-wide delegation for Trustero's client, please follow the<br />\ninstructions below. Consult Google's support pages for additional information<br />\nabout this process:</p>\n<ul>\n<li><a href=\"https://support.google.com/a/answer/162106\" target=\"_blank\" rel=\"noopener noreferrer\">Google's Domain-Wide delegation concept</a></li>\n</ul>\n<h2 id=\"grant-authorization-to-trustero-api-client\">Grant Authorization to Trustero API Client</h2>\n<ol>\n<li>From your Google Workspace domain's <a href=\"http://admin.google.com\" target=\"_blank\" rel=\"noopener noreferrer\">Admin console</a>, go to <strong>Main menu</strong> -&gt; <strong>Security</strong> -&gt; <strong>Access and Data control</strong> -&gt; <strong>API controls</strong>.</li>\n<li>In the <strong>Domain wide delegation</strong> section at the bottom of the page, click <strong>Manage Domain Wide Delegation</strong>.</li>\n<li>Click <strong>Add new</strong> to add a new API client.</li>\n<li>In the <strong>Client ID</strong> field, enter Trustero's client ID:<br />\n<code>102549316727231465801</code></li>\n<li>In the <strong>Oauth Scopes</strong> field, paste the scopes outlined in the <strong><em>Oauth 2.0\nScopes</em></strong> section below.</li>\n<li>Click <strong>Authorize</strong></li>\n</ol>\n<h3 id=\"oauth-20-scopes\">Oauth 2.0 Scopes</h3>\n<pre><code>https://www.googleapis.com/auth/admin.directory.device.chromeos.readonly,\nhttps://www.googleapis.com/auth/admin.directory.device.mobile.readonly,\nhttps://www.googleapis.com/auth/admin.directory.group.readonly,\nhttps://www.googleapis.com/auth/admin.directory.orgunit.readonly,\nhttps://www.googleapis.com/auth/admin.directory.rolemanagement.readonly,\nhttps://www.googleapis.com/auth/admin.directory.user.readonly,\nhttps://www.googleapis.com/auth/admin.reports.audit.readonly,\nhttps://www.googleapis.com/auth/admin.reports.usage.readonly,\nhttps://www.googleapis.com/auth/cloud-platform,\nhttps://www.googleapis.com/auth/admin.directory.group.member.readonly,\nhttps://www.googleapis.com/auth/admin.directory.group.readonly,</code></pre>\n<h2 id=\"credentials\">Credentials</h2>\n<p>In the fields below, please provide the <strong><em>domain</em></strong> of your Google Workspace<br />\norganization, as well as the email of the Google Workspace account which is a<br />\n\"Super Admin\" in the organization.</p>\n<p>If you have multiple domains, you will need to add multiple receptors\u2026 one for each domain.<br />\nWe suggest that you use the domain name as the <strong><em>nickname</em></strong> for each receptor.</p>",
iscredvalid: false,
service_ids: ["trs73"],
control_ids: ["trc36", "trc38", "trc39", "trc40", "trc43", "trc63", "trc64", "trc65", "trc66", "trc68", "trc1025", "trc1033", "trc1037", "trc1062", "trc1083", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4092", "IM03"],
logo: logos.Google,
category: "Productivity Suite",
type: 0,
field_template: [
    {
        "display": "Organization Domain",
        "placeholder": "Domain",
        "field": "domain"
    },
    {
        "display": "Delegate User",
        "placeholder": "Email",
        "field": "delegate",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-trinet",
name: "TriNet Receptor",
content: "<h2 id=\"the-trinet-receptor-must-be-set-up-by-someone-who-is-assigned-a-role-of-integration-administrator\">The TriNet receptor must be set up by someone who is assigned a role of <code>Integration Administrator</code></h2>\n<p>The TriNet receptor can scan your organization's employee roster to build<br />\nevidence of compliance for a number of controls.</p>\n<p>To enable the receptor, please follow the steps outlined below. Once this is completed, you'll be able to generate OAuth credentials<br />\nTrustero can use to access TriNet on your behalf.</p>\n<ol>\n<li>Sign in to<a href=\"https://identity.trinet.com\" target=\"_blank\" rel=\"noopener noreferrer\">TriNet</a> portal.</li>\n<li>Navigate to the TriNet Integration Center(<code>Admin</code>-&gt;<code>Manager</code>-&gt;<code>Integration Center</code>).</li>\n<li>Go to the <code>Available Apps</code> tab.</li>\n<li>Scroll down and locate <code>Trinet API</code> and click <code>Get Started</code>.</li>\n<li>From the <code>Trinet API</code> section select <code>Get Started</code> ( all the way at the bottom).</li>\n<li>From the <code>Select an Integration</code> select <code>Trustero</code>  dropdown and click <code>Accept</code>.</li>\n<li>Copy the provided <strong>Company ID</strong>, <strong>Client ID</strong> and <strong>Client Secret</strong>. Do not navigate away from this page until you complete the next step.</li>\n<li>Enter <strong>Company ID</strong>, <strong>Client ID</strong> and <strong>Client Secret</strong> into the form below and click <code>Activate</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs78"],
control_ids: ["trc38", "trc39", "trc40", "trc43", "trc44", "trc64", "trc65", "trc68", "trc1025", "trc1033", "trc1062", "trc1083", "trc4053", "HR02"],
logo: logos.TriNet,
category: "Human Resources Information System",
type: 0,
field_template: [
    {
        "display": "Company Id",
        "placeholder": "Company Id",
        "field": "company_id"
    },
    {
        "display": "Client ID",
        "placeholder": "Client ID",
        "field": "key"
    },
    {
        "display": "Client Secret",
        "placeholder": "Secret",
        "field": "secret",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-recruitee",
name: "Recruitee Receptor",
content: "<p>The Recruitee receptor can scan your organization's recruitement data to build<br />\nevidence of compliance for a number of controls.</p>\n<p>To enable the receptor, please use the ADMIN acount on Recruitee for your<br />\norganization and follow the steps in the Recruitee API Reference to get a new<br />\nAPI token. You will also need the Company ID, detailed instructions below:</p>\n<ol>\n<li>Go to the <a href=\"https://docs.recruitee.com/reference/getting-started#generate-api-token\" target=\"_blank\" rel=\"noopener noreferrer\">Recruitee API Reference</a> and follow their steps to <strong><code>Generate API Token</code></strong><ul>\n<li>name the newly generated token: <strong>Trustero API Token</strong></li></ul></li>\n<li>Copy the provided <strong>Company ID</strong> and newly generated <strong>Token ID</strong> into the form below<ul>\n<li>The <strong>Company ID</strong> is the ID number listed below the <strong>Company Name</strong></li></ul></li>\n</ol>",
iscredvalid: false,
service_ids: ["trs48"],
control_ids: ["trc0", "trc4056", "HR05"],
logo: logos.Recruitee,
category: "Applicant Tracking System",
type: 0,
field_template: [
    {
        "display": "Company Id",
        "placeholder": "Company Id",
        "field": "company_id"
    },
    {
        "display": "API Token",
        "placeholder": "API Token",
        "field": "api_token",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-jamf",
name: "Jamf Receptor",
content: "<p>Trustero will scan security settings of devices in your organization that are Jamf-enabled</p>\n<p>To use this receptor, you will need to have the Jamf Pro service, not Jamf Now.</p>\n<p>Trustero's Jamf receptor requires a Jamf API Role and API Client setup. Please follow the instructions below in Jamf to create a new API Role and API Client.  </p>\n<h2 id=\"create-a-new-api-role\">Create a new API Role</h2>\n<ol>\n<li>In Jamf Pro, click <strong>Settings</strong>  in the sidebar.</li>\n<li>In the <strong>System</strong> section, click <strong>API Roles and Clients</strong> .</li>\n<li>Click the <strong>API Roles</strong> tab at the top of the pane.</li>\n<li>Click <strong>+ New</strong> button.</li>\n<li>Enter <strong><em>trustero-api-role</em></strong> in the Display Name field.</li>\n<li>In the Jamf Pro API role Privileges field, begin typing the name of each privilege listed below to assign, and then select it from the pop-up menu.<ul>\n<li>Read Accounts</li>\n<li>Read Computers</li>\n<li>Read User</li>\n<li>Read macOS Configuration Profiles</li></ul></li>\n<li>Click <strong>Save</strong>.</li>\n</ol>\n<h2 id=\"create-a-new-api-client\">Create a new API Client</h2>\n<ol>\n<li>Click the <strong>APl Clients</strong> tab at the top of the pane.</li>\n<li>Click <strong>+ New</strong> .</li>\n<li>Enter <em>trustero-api-client</em> in the Display Name field.</li>\n<li>In the API Roles field, click on the drop down and select <strong><em>trustero-api-role</em></strong> created in the <strong>Create a new API Role</strong> section above.</li>\n<li>Enter <strong><em>3600</em></strong> in the Access Token Lifetime field.</li>\n<li>Click <strong>Enable API Client</strong>.</li>\n<li>Click <strong>Generate client secret</strong> and <strong>Create secret</strong> in the pop-up. Save this client id and client secret in a secure location.</li>\n<li>Click <strong>Save</strong>.</li>\n</ol>\n<p>Enter the client id, client secret, and Jamf Pro URL in the Trustero Jamf receptor configuration below.</p>",
iscredvalid: false,
service_ids: ["trs86", "trs99", "trs122"],
control_ids: ["trc26", "trc29", "trc36", "trc37", "trc39", "trc40", "trc43", "trc49", "trc61", "trc64", "trc65", "trc66", "trc68", "trc86", "trc87", "trc1033", "trc1037", "trc1076", "trc1082", "trc1083", "trc1088", "trc1105", "trc1110", "trc4005", "AM02", "trc4007", "AM04", "trc4073", "SC03"],
logo: logos.Jamf,
category: "Mobile Device Management",
type: 0,
field_template: [
    {
        "display": "Jamf Cloud URL",
        "placeholder": "url",
        "field": "base_url"
    },
    {
        "display": "Client ID",
        "placeholder": "client ID",
        "field": "client_id"
    },
    {
        "display": "Client Secret",
        "placeholder": "client secret",
        "field": "client_secret",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-gcp",
name: "Google Cloud Platform Receptor",
content: "<p>Please use the same credentials for Google Cloud Platform and Google Workspace</p>\n<p>The Google Cloud Platform receptor scans settings under your organization's domain to<br />\ngather as much evidence of SOC2 compliance as possible.</p>\n<p>To set up domain-wide delegation for Trustero's client, please follow the<br />\ninstructions below. Consult Google's support pages for additional information<br />\nabout this process:</p>\n<ul>\n<li><a href=\"https://support.google.com/a/answer/162106\" target=\"_blank\" rel=\"noopener noreferrer\">Google's Domain-Wide delegation concept</a></li>\n</ul>\n<h2 id=\"grant-authorization-to-trustero-api-client\">Grant Authorization to Trustero API Client</h2>\n<ol>\n<li>From your Google Workspace domain's <a href=\"http://admin.google.com\" target=\"_blank\" rel=\"noopener noreferrer\">Admin console</a>, go to <strong>Main menu</strong> -&gt; <strong>Security</strong> -&gt; <strong>Access and Data control</strong> -&gt; <strong>API controls</strong>.</li>\n<li>In the <strong>Domain wide delegation</strong> section at the bottom of the page, click <strong>Manage Domain Wide Delegation</strong>.</li>\n<li>Click <strong>Add new</strong> to add a new API client.</li>\n<li>In the <strong>Client ID</strong> field, enter Trustero's client ID:<br />\n<code>102549316727231465801</code></li>\n<li>In the <strong>Oauth Scopes</strong> field, paste the scopes outlined in the <strong><em>Oauth 2.0\nScopes</em></strong> section below.</li>\n<li>Click <strong>Authorize</strong></li>\n</ol>\n<h3 id=\"oauth-20-scopes\">Oauth 2.0 Scopes</h3>\n<pre><code>https://www.googleapis.com/auth/admin.directory.device.chromeos.readonly,\nhttps://www.googleapis.com/auth/admin.directory.device.mobile.readonly,\nhttps://www.googleapis.com/auth/admin.directory.group.readonly,\nhttps://www.googleapis.com/auth/admin.directory.orgunit.readonly,\nhttps://www.googleapis.com/auth/admin.directory.rolemanagement.readonly,\nhttps://www.googleapis.com/auth/admin.directory.user.readonly,\nhttps://www.googleapis.com/auth/admin.reports.audit.readonly,\nhttps://www.googleapis.com/auth/admin.reports.usage.readonly,\nhttps://www.googleapis.com/auth/cloud-platform,\nhttps://www.googleapis.com/auth/admin.directory.group.member.readonly,\nhttps://www.googleapis.com/auth/admin.directory.group.readonly,</code></pre>\n<h2 id=\"credentials\">Credentials</h2>\n<p>In the fields below, please provide the <strong><em>domain</em></strong> of your Google Workspace<br />\norganization, as well as the email of the Google Workspace account which is a<br />\n\"Super Admin\" in the organization.</p>\n<p>If you have multiple domains, you will need to add multiple receptors\u2026 one for each domain.<br />\nWe suggest that you use the domain name as the <strong><em>nickname</em></strong> for each receptor.</p>",
iscredvalid: false,
service_ids: ["trs88", "trs89", "trs90", "trs112", "trs117"],
control_ids: ["trc36", "trc38", "trc39", "trc40", "trc43", "trc63", "trc64", "trc65", "trc66", "trc68", "trc86", "trc1025", "trc1033", "trc1037", "trc1062", "trc1083", "trc1096", "trc1097", "trc1110", "trc4004", "AM01", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4072", "SC02", "trc4092", "IM03", "trc4106", "VM02"],
logo: logos.GCP,
category: "Cloud Provider",
type: 0,
field_template: [
    {
        "display": "Organization Domain",
        "placeholder": "Domain",
        "field": "domain"
    },
    {
        "display": "Delegate User",
        "placeholder": "Email",
        "field": "delegate",
        "input_type": "password"
    }
],
config_template: [
    {
        "title": "GCP Project Configuration",
        "description": "Configure the GCP projects to fetch data from. Enter one project ID per line.",
        "fields": [
            {
                "display": "Project IDs",
                "placeholder": "Enter one project ID per line",
                "input_type": "text",
                "field": "project-id"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-gitlab",
name: "GitLab Receptor",
content: "<p>Create a read-only connection so Trustero can pull information from your Gitlab account and use it as evidence for your controls. You can deactivate this at any time here, or in the Gitlab app</p>\n<p>To get the group ID</p>\n<ol>\n<li>Login.</li>\n<li>Go to <strong>Groups</strong>.</li>\n<li>Select a group.</li>\n<li>Select the <strong>Settings</strong> navigation from the left sidebar.</li>\n<li>Select <strong>General</strong>.</li>\n<li>Copy the <code>group ID</code> under the <strong>Naming, description, visibility</strong> section.</li>\n<li>Paste the <code>group ID</code> into the <strong>Group ID</strong> field.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs25", "trs125"],
control_ids: ["trc12", "trc38", "trc39", "trc40", "trc43", "trc44", "trc63", "trc64", "trc65", "trc68", "trc1025", "trc1033", "trc1086", "trc1113", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4078", "SD02"],
logo: logos.GitLab,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "GroupID",
        "placeholder": "GroupID",
        "field": "GroupID",
        "method": "oauth"
    }
],
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-bitbucket",
name: "Bitbucket Receptor",
content: "<p>First get your bitbucket username</p>\n<ol>\n<li>In the top-right corner, select your avatar.</li>\n<li>Select <strong>Personal settings</strong>.</li>\n<li>Under <strong>Bitbucket profile settings</strong> get the value in <code>Username</code>.</li>\n</ol>\n<p>Next, create a read-only personal access token</p>\n<ol>\n<li>In the top-right corner, select your avatar.</li>\n<li>Select <strong>Personal settings</strong>.</li>\n<li>On the left sidebar, select <strong>App passwords</strong>.</li>\n<li>Under the <strong>App passwords</strong> select <strong>Create app password</strong>.</li>\n<li>Select the following permissions.<ul>\n<li><strong>Account</strong>: Read</li>\n<li><strong>Workspace membership</strong>: Read </li>\n<li><strong>Projects</strong>: Read</li>\n<li><strong>Repositories</strong>: Read (Should be selected automatically by <strong>Projects</strong>)</li></ul></li>\n<li>Select <strong>Create</strong>.</li>\n<li>Give your token a label.</li>\n<li>Copy the API token into into the <strong>password</strong> field.</li>\n</ol>\n<p>Finally pick the workspace you want to scan</p>\n<ol>\n<li>In the top-right corner, select your avatar.</li>\n<li>Select <strong>All workspaces</strong>.</li>\n<li>Under <strong>Workspaces</strong> get the value in the <code>Workspace</code> column you want to scan.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs24", "trs121"],
control_ids: ["trc12", "trc38", "trc39", "trc40", "trc43", "trc44", "trc63", "trc64", "trc65", "trc68", "trc1025", "trc1033", "trc1086", "trc1113", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4078", "SD02"],
logo: logos.Bitbucket,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "Username",
        "placeholder": "username",
        "field": "Username"
    },
    {
        "display": "Workspace",
        "placeholder": "workspace",
        "field": "Workspace"
    },
    {
        "display": "AppPassword",
        "placeholder": "apppassword",
        "field": "AppPassword",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-custom",
name: "Custom Receptor",
content: "<h1 id=\"custom-receptors-high-level-steps\">Custom Receptors: High Level Steps</h1>\n<h2 id=\"1-build-your-custom-receptor\"><strong>1. Build Your Custom Receptor</strong></h2>\n<ol>\n<li>Build your custom receptor. Useful resources:<ul>\n<li><a href=\"https://github.com/trustero/Receptor-Template\" target=\"_blank\" rel=\"noopener noreferrer\">Receptor Template</a></li>\n<li><a href=\"https://github.com/trustero/api\" target=\"_blank\" rel=\"noopener noreferrer\">Receptor SDK</a></li></ul></li>\n</ol>\n<pre><code>NOTE: Your receptor's GetReceptorType function must return \"trr-custom\", and you must use \"Custom Service\" as your service name.</code></pre>\n<h2 id=\"2-add-your-custom-receptor-to-the-application\"><strong>2. Add Your Custom Receptor to the Application</strong></h2>\n<ol>\n<li>In the Trustero application, navigate to the <strong>Receptors</strong> tab of the <strong>Services</strong> page. (Click on Content &gt; Services in the lefthand navigation bar).</li>\n<li>Click on the <strong>Add Receptor</strong> button, which will open a modal displaying supported receptors. </li>\n<li>At the bottom of the modal, click on the text that reads <strong>Add a custom receptor</strong>.</li>\n<li>Enter a nickname for your receptor and click <strong>Activate</strong>.</li>\n</ol>\n<h2 id=\"3-get-your-receptor-token-and-id\"><strong>3. Get Your Receptor Token and Id</strong></h2>\n<ol>\n<li>Select your new custom receptor from the list on the <strong>Receptors</strong> page.</li>\n<li>Select the <strong>Custom Receptor Config</strong> tab.</li>\n<li>Click <strong>Receptor ID</strong> to copy the ID to your clipboard.</li>\n<li>Click <strong>Receptor Token</strong> to copy the token to your clipboard.</li>\n</ol>\n<h2 id=\"4-verify-and-run-your-receptor\"><strong>4. Verify and Run Your Receptor</strong></h2>\n<ol>\n<li>This is the general form for CLI commands to run your receptor. For <code>&lt;receptor_credentials&gt;</code> simply list out the credentials for your receptor in order:</li>\n</ol>\n<pre><code>$ go run ./&lt;receptor-name&gt; &lt;verb&gt; &lt;receptor token&gt; &lt;receptor credentials&gt; --receptor-id &lt;receptor id&gt; -s prod.api.infra.trustero.com</code></pre>\n<ol start=\"2\">\n<li>In order to verify your receptor, you can run the following command, replacing default values with the appropriate values for your receptor:</li>\n</ol>\n<pre><code>$ go run ./&lt;receptor-name&gt; verify &lt;receptor token&gt; &lt;receptor credentials&gt; --receptor-id &lt;receptor id&gt; -s prod.api.infra.trustero.com</code></pre>\n<ol start=\"3\">\n<li>In order to add evidence using your receptor, you can run the following command, replacing default values with the appropriate values for your receptor:</li>\n</ol>\n<pre><code>$ go run ./&lt;receptor-name&gt; scan &lt;receptor token&gt; &lt;receptor credentials&gt; --receptor-id &lt;receptor id&gt; --find-evidence -s prod.api.infra.trustero.com</code></pre>\n<h2 id=\"5-add-evidence-to-specific-controls-using-your-receptor\"><strong>5. Add Evidence to Specific Controls Using Your Receptor</strong></h2>\n<ol>\n<li>Navigate to the <strong>Controls</strong> page in the application (click on Content &gt; Controls in the lefthand navigation bar).</li>\n<li>Select which control you would like to connect to your receptor.</li>\n<li>On the control's show page, select the <strong>Automated Evidence</strong> tab.</li>\n<li>Click on <strong>Connect Automated Evidence</strong>.</li>\n<li>Select the row item labeled <code>Custom Receptor: &lt;Service Entity Type&gt;</code>, where <code>&lt;Service Entity Type&gt;</code> is the service entity type for which you would like to collect evidence.</li>\n<li>Run the <strong>scan</strong> command from the previous section whenever you would like to collect evidence and post it to the control(s) connected to your receptor.</li>\n</ol>",
iscredvalid: false,
service_ids: [],
control_ids: [""],
logo: logos.CustomReceptor,
category: "Code Your Own",
type: 0
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-deepsource",
name: "DeepSource",
content: "<p>Token generation in DeepSource  </p>\n<ol>\n<li>Select your account on the bottom left of the screen</li>\n<li>When <strong>Settings</strong> appears please select this</li>\n<li>On the Personal Access Tokens screen <strong>Generate new token</strong> will appear please select it.</li>\n<li>Put a label in your token and decide on expiration, remember you will have to generate a new token if one has expired.</li>\n<li>Select <strong>Copy</strong> and place paste the token in the Token field.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs98", "trs118"],
control_ids: ["trc14", "trc1109", "trc4077", "SD01", "", "trc37", "trc38", "trc39", "trc40", "trc43", "trc63", "trc64", "trc65", "trc66", "trc68", "trc1025", "trc1033", "trc1037", "trc1083", "trc1086"],
logo: logos.Deepsource,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "Token",
        "placeholder": "Token",
        "field": "Token",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-checkr",
name: "Checkr",
content: "<p>Create a read-only connection so Trustero can pull information from your Checkr account and use it as evidence for your controls. You can deactivate this at any time here, or in the Checkr app.</p>",
iscredvalid: false,
service_ids: ["trs77"],
control_ids: ["trc3", "trc1060", "trc4053", "HR02"],
logo: logos.Checkr,
category: "Business Services and Tools",
type: 0,
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-azure",
name: "Azure Receptor",
content: "<p>The <code>Azure</code> receptor allows you to attach Azure resource metadata as evidence to compliance controls within Trustero. It connects to your Azure subscription to retrieve data from services such as Virtual Machines, Storage Accounts, App Services, and other managed resources.</p>\n<p>Register the application within Azure using the <a href=\"https://support.trustero.com/knowledge/microsoft-app-registration-setup-guide\" target=\"_blank\" rel=\"noopener noreferrer\">App Registration instructions</a>. Then, configure the permissions of the Azure Resource Groups using the <a href=\"https://support.trustero.com/knowledge/azure-receptor\" target=\"_blank\" rel=\"noopener noreferrer\">Granting Permissions to Resource Groups instructions</a>.</p>\n<h2 id=\"to-enable-the-receptor-follow-the-steps-below\">To enable the receptor, follow the steps below:</h2>\n<ol>\n<li>Choose a nickname for your <code>Azure</code> receptor in the Trustero configuration screen.  </li>\n<li>Locate the following values from your Azure App Registration:  <ul>\n<li><code>Client ID</code>  </li>\n<li><code>Client Secret</code>  </li>\n<li><code>Tenant ID</code>  </li></ul></li>\n<li>Switch back to the Trustero configuration screen and enter the <code>Client ID</code>, <code>Secret</code>, and <code>Tenant ID</code> into their respective fields.  </li>\n<li>Click <code>Accept</code> to activate the receptor.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs53", "trs102", "trs104", "trs105", "trs106", "trs108", "trs113", "trs168", "trs195", "trs196", "trs200", "trs201", "trs202", "trs203", "trs206", "trs207", "trs232", "trs233"],
control_ids: ["trc26", "trc37", "trc38", "trc39", "trc40", "trc43", "trc49", "trc61", "trc63", "trc64", "trc65", "trc66", "trc68", "trc85", "trc86", "trc87", "trc1025", "trc1031", "trc1033", "trc1037", "trc1076", "trc1082", "trc1083", "trc1086", "trc1088", "trc1103", "trc1105", "trc1110", "trc4004", "AM01", "trc4005", "AM02", "trc4007", "AM04", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4073", "SC03"],
logo: logos.Azure,
category: "Cloud Provider",
type: 0,
field_template: [
    {
        "display": "Tenant ID",
        "placeholder": "Directory (Tenant) ID",
        "field": "tenant_id"
    },
    {
        "display": "Client ID",
        "placeholder": "Application (Client) ID",
        "field": "client_id"
    },
    {
        "display": "Client Secret",
        "placeholder": "Client Secret Value",
        "field": "client_secret",
        "input_type": "password"
    }
],
config_template: [
    {
        "title": "Control To Policy Mappings",
        "description": "Add mappings between Intune policies and the controls in your account.",
        "fields": [
            {
                "display": "Policy",
                "placeholder": "Policy",
                "input_type": "control_mapping",
                "field": "filters",
                "evidence_caption": "Intune Policy",
                "service_model_id": "trs232"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-datadog",
name: "Datadog Receptor",
content: "<h1 id=\"datadog-receptor\">Datadog Receptor</h1>\n<p>You will need both an <strong>API Key</strong> and an<br />\n<strong>Application Key</strong>.</p>\n<h2 id=\"add-an-api-key\">Add an API Key</h2>\n<ol>\n<li>Mouse over your avatar.</li>\n<li>Click <strong>Organization settings</strong>.</li>\n<li>Click the <strong>API Keys</strong> tab.</li>\n<li>Click the <strong>New Key</strong> button.</li>\n<li>Enter a name for your key.</li>\n<li>Click <strong>Create Key</strong>.</li>\n</ol>\n<h2 id=\"add-an-application-key\">Add an Application Key</h2>\n<ol>\n<li>Mouse over your avatar.</li>\n<li>Click <strong>Organization settings</strong>.</li>\n<li>Click the <strong>Application Keys</strong> tab.</li>\n<li>Click the <strong>New Key</strong> button.</li>\n<li>Enter a name for your key.</li>\n<li>Click <strong>Create Key</strong>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs107", "trs109"],
control_ids: ["trc37", "trc38", "trc39", "trc40", "trc43", "trc63", "trc64", "trc65", "trc66", "trc68", "trc102", "trc1025", "trc1033", "trc1037", "trc1083", "trc1086", "trc1096", "trc1097", "trc4091", "IM02", "trc4095", "IM06"],
logo: logos.Datadog,
category: "Cloud Monitoring as a Service",
type: 0,
field_template: [
    {
        "display": "API Key",
        "placeholder": "apikey",
        "field": "ApiKey"
    },
    {
        "display": "Application Key",
        "placeholder": "appkey",
        "field": "AppKey",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-github",
name: "GitHub Receptor",
content: "<p>Trustero supports multiple ways to configure how the GitHub Receptor authenticates to GitHub. Please follow the instructions below to provide necessary credentials.  </p>\n<p><strong>Instructions:</strong>  </p>\n<p>Method 1:  <strong>GitHub App</strong></p>\n<ol>\n<li>Enter a nickname for the receptor and click <code>Activate</code>.</li>\n<li>If not logged into your GitHub account, you will be prompted by GitHub to login.</li>\n<li>Select the Organization where the app will be installed.</li>\n<li>Select the repositories that you need Trustero to collect information for.</li>\n<li>Click <code>Install &amp; Authorize</code>.</li>\n<li>Enter the MFA information on the screen if prompted and click <code>Verify</code>.</li>\n<li>If you are not the owner of the application, GitHub will send a request to the owner to approve the installation.</li>\n</ol>\n<p>Method 2:  <strong>OAuth App</strong></p>\n<p>To activate receptor with this method , you will need the name of your organization in GitHub.<br />\nPlease login to your GitHub account and go to the following link: <a href=\"https://github.com/settings/organizations\" target=\"_blank\" rel=\"noopener noreferrer\">GitHub Organizations</a></p>\n<p>In the form below, please enter the name of your organization exactly as it appears on this page.</p>\n<p>The following steps must be done by someone who is an <strong>Owner</strong> of your organization.</p>\n<ol>\n<li>Choose a nickname and which organization you are going to scan.</li>\n<li>Press activate and you will be redirected to GitHub to authorize access.</li>\n<li>Click the <code>Grant</code> button next to the <code>trustero</code> organization.</li>\n<li>Click the green <code>Authorize trustero</code> button.</li>\n</ol>\n<p><strong>NOTE:</strong> If your organization has OAuth app access restrictions enabled, an owner may need to grant access in GitHub's UI: <a href=\"https://docs.github.com/en/organizations/managing-oauth-access-to-your-organizations-data/approving-oauth-apps-for-your-organization\">https://docs.github.com/en/organizations/managing-oauth-access-to-your-organizations-data/approving-oauth-apps-for-your-organization</a></p>",
iscredvalid: false,
service_ids: ["trs2", "trs110", "trs133"],
control_ids: ["trc12", "trc14", "trc37", "trc38", "trc39", "trc40", "trc43", "trc63", "trc64", "trc65", "trc66", "trc68", "trc1025", "trc1033", "trc1037", "trc1083", "trc1086", "trc1109", "trc1110", "trc1113", "trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4077", "SD01", "trc4078", "SD02", "trc4080", "SD04"],
logo: logos.GitHubMark,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "Organization",
        "placeholder": "org",
        "field": "org",
        "method": "oauth"
    }
],
methods: [
    {
        "display": "Github Apps",
        "value": "oauth_app"
    },
    {
        "display": "OAuth Apps",
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-bamboohr",
name: "Bamboo HR Receptor",
content: "<p>To setup BambooHR receptor you will need to know the subdomain of your BambooHR setup.<br />\nFor example if you log in to <strong>example.bamboohr.com</strong> you would place <strong>example</strong> in the Company area.</p>",
iscredvalid: false,
service_ids: ["trs111", "trs199"],
control_ids: ["trc38", "trc39", "trc40", "trc43", "trc44", "trc64", "trc65", "trc68", "trc1025", "trc1033", "trc1062", "trc1083", "trc4014", "IAM05", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4058", "HR07"],
logo: logos.BambooHR,
category: "Human Resources Information System",
type: 0,
field_template: [
    {
        "display": "Company",
        "placeholder": "company",
        "field": "Org",
        "method": "oauth"
    }
],
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-curricula",
name: "Huntress Managed SAT Receptor",
content: "<p>You must have a paid Huntress Managed SAT account to use this receptor. <br />\nYou must be an Admin on Huntress Managed SAT to set up this receptor</p>\n<h3 id=\"to-register-your-huntress-managed-sat-with-trustero-follow-these-steps\">To register your Huntress Managed SAT with Trustero, follow these steps:</h3>\n<ol>\n<li>You will need to activate API access for your Huntress Managed SAT account. <ol>\n<li>Contact <a href=\"&#x6d;&#x61;&#x69;&#108;&#116;&#x6f;:&#x73;&#x75;&#112;p&#111;&#x72;&#x74;&#64;&#104;&#x75;&#x6e;&#116;r&#101;&#x73;&#x73;&#46;&#99;&#x6f;&#x6d;\">s&#117;&#112;&#112;&#x6f;r&#x74;&#x40;&#x68;&#117;&#x6e;&#x74;&#x72;&#x65;&#115;&#x73;&#x2e;&#x63;&#x6f;&#109;</a> and ask that API access be turned on for your account.</li></ol></li>\n<li>Navigate to \u201cmycurricula.com\u201d and log in.</li>\n<li>Once the website loads, look for the top menu and click on the \u201cSettings\u201d option.</li>\n<li>On the left-hand side of the screen, you will see a list of options. Click on \u201cAPI Clients\u201d. <ul>\n<li><strong>If you do not see the \u201cAPI Clients\u201d option, then API access has not been activated for your account. Please complete step 1</strong></li></ul></li>\n<li>On the API Clients page, you will see a button labeled \u201cCreate Client\u201d. Click on this button to create new API credentials.</li>\n<li>In the popup window that appears, you will need to enter some information to create the new API credentials.<ol>\n<li>In the \u201cClient name\u201d field, type \u201cTrustero Huntress Managed SAT receptor\u201d.</li>\n<li>In the \u201cClient Type\u201d field, select \u201cClient Credentials\u201d from the dropdown menu.</li></ol></li>\n<li>Once you have entered all the required information, click on the \u201cCreate\u201d button to generate your new API credentials.</li>\n<li>You will now see your newly generated API credentials displayed on the API Clients page. Make sure to enter the Client ID and Secret below.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs123", "trs124"],
control_ids: ["trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4057", "HR06", "trc4078", "SD02"],
logo: logos.Curricula,
category: "Security Awareness Training",
type: 0,
field_template: [
    {
        "display": "Client ID",
        "placeholder": "Client ID",
        "field": "clientID"
    },
    {
        "display": "Client Secret",
        "placeholder": "Client Secret",
        "field": "secret",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-snyk",
name: "Snyk Receptor",
content: "<p>The Snyk receptor requires that you have an Enterprise Sneak account.<br />\nYou must be an Admin on Snyk to set up this receptor.</p>\n<h3 id=\"to-register-your-snyk-with-trustero-follow-these-steps\">To register your Snyk with Trustero, follow these steps:</h3>\n<ol>\n<li>Navigate to <a href=\"https://app.snyk.io/login\" target=\"_blank\" rel=\"noopener noreferrer\">Snyk</a> and log in to the Organization you want to connect to Trustero.</li>\n<li>Under the <code>ORGANIZATION</code> section on the left side of the screen, click on  <code>Settings</code>.</li>\n<li>Under the <code>ORGANIZATION SETTINGS</code> section on the left side of the screen, click on <code>Service accounts</code>.</li>\n<li>In the <code>Create a new service account</code> section, enter a name for the service account. We recommend <code>Trustero Snyk receptor</code>. For <code>Role</code> select <code>Org Admin</code>.</li>\n<li>Click on the <code>Create</code> button.</li>\n<li>You will now see your newly generated API credentials displayed on the Service accounts page. Copy this token to enter the <code>API Token</code> below.</li>\n<li>Navicate to the <code>General</code> section on under <code>ORGANIZATION SETTINGS</code>.</li>\n<li>Copy the <code>Organization ID</code> and enter it below.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs127", "trs126"],
control_ids: ["SD01", "IAM05"],
logo: logos.Snyk,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "Organization ID",
        "placeholder": "Organization ID",
        "field": "org_id"
    },
    {
        "display": "API Token",
        "placeholder": "API Token",
        "field": "api_token",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-miradore",
name: "Miradore Receptor",
content: "<p>The Miradore receptor requires that you have an Premium plan.<br />\nYou must be an Admin on Miradore to set up this receptor.</p>\n<h3 id=\"to-register-your-miradore-with-trustero-follow-these-steps\">To register your Miradore with Trustero, follow these steps:</h3>\n<ol>\n<li>Navigate to <a href=\"https://online.miradore.com/Login/Login\" target=\"_blank\" rel=\"noopener noreferrer\">Miradore</a> and log in.</li>\n<li>Click on your existing site that you wish to connect to Trustero.</li>\n<li>Under the <code>System</code> section on the left side of the screen, click on <code>Infrastructure diagram</code>.</li>\n<li>Scroll down to click on <code>API</code> and <code>Create key</code> - the <code>Create key</code> form will open on the top of the screen.</li>\n<li>Enter a name, preferrably <code>trustero-api-key</code>, and click on <code>Next</code>.</li>\n<li>Confirm the entries and copy the displayed key to a safe place.</li>\n<li>Click on <code>Create key</code> at the bottom of the form.</li>\n<li>Close the form and paste the <code>API Key</code> below in the <code>API key</code> field and Site Name in the <code>Site Name</code> field.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs129"],
control_ids: ["trc26", "trc29", "trc36", "trc37", "trc39", "trc40", "trc43", "trc49", "trc61", "trc64", "trc65", "trc66", "trc68", "trc86", "trc87", "trc1033", "trc1037", "trc1076", "trc1082", "trc1083", "trc1088", "trc1105", "trc1110", "trc4005", "trc4007", "trc4073", "AM01", "AM04", "AM06", "SC03", "SC05"],
logo: logos.Miradore,
category: "Mobile Device Management",
type: 0,
field_template: [
    {
        "display": "Site Name",
        "placeholder": "Site Name",
        "field": "site_name"
    },
    {
        "display": "API Key",
        "placeholder": "API Key",
        "field": "api_key",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-sophos",
name: "Sophos Receptor",
content: "<h3 id=\"to-register-your-sophos-with-trustero-follow-these-steps\">To register your Sophos with Trustero, follow these steps:</h3>\n<ol>\n<li>Sign in to Sophos Central &gt; Global Settings &gt;  API Credentials Management ( Under <code>Administration</code>)</li>\n<li>Click <code>Add Credential</code> button</li>\n<li>Supply a name for your credential set and a description, then click <code>Add</code></li>\n<li>Click <code>Copy</code> to note down the client ID. Also show the client secret</li>\n<li>Click <code>Copy</code> to note down the client secret</li>\n<li>Paste the client ID and client secret below in the <code>Client ID</code> and <code>Client Secret</code> fields respectively</li>\n<li>Click <code>Activate</code> to add the receptor to your Trustero account</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs157", "trs170"],
control_ids: ["IAM05", "AM04", "SC03", "AM06", "SC05"],
logo: logos.Sophos,
category: "Cloud Malware and Threat Prevention",
type: 0,
field_template: [
    {
        "display": "Client ID",
        "placeholder": "Client ID",
        "field": "client_id"
    },
    {
        "display": "Client Secret",
        "placeholder": "Client Secret",
        "field": "client_secret",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-jumpcloud",
name: "JumpCloud Receptor",
content: "<p>In order to use JumpCloud, you must provide JumpCloud API Key.  We recommend you create a read-only user for this purpose.<br />\nFollow these steps to <strong>create</strong> a user with Read-Only role and generate an API Key for the user.</p>\n<p>Create <strong>Administrator</strong> account: (Only Admins with <strong>Billing role</strong> can enable API access)</p>\n<ol>\n<li>Log into the <a href=\"https://console.jumpcloud.com/login\" target=\"_blank\" rel=\"noopener noreferrer\">JumpCloud Admin Portal</a>.</li>\n<li>In the top right corner, click the circle with your initials to access your JumpCloud account menu.</li>\n<li>Click <code>Administrators</code>. This will take you to the <code>Settings</code> page, <code>Administrators</code> tab.</li>\n<li>Click ( <code>+</code> ) to add a new admin.</li>\n<li>Enter the admin\u2019s <code>First Name</code> and <code>Last Name</code>. The <code>Administrator Email Address</code> has to be unique.</li>\n<li>Under <code>Permissions</code>, select a <code>Role</code> drop down and select <code>Read Only</code>.</li>\n<li>Select the checkbox next to <code>Enable API access</code>.</li>\n<li>Click create.</li>\n</ol>\n<p>Generate <strong>API Key</strong>:</p>\n<ol>\n<li>Log into the <a href=\"https://console.jumpcloud.com/login\" target=\"_blank\" rel=\"noopener noreferrer\">JumpCloud Admin Portal</a> as the Read-Only role user created above.</li>\n<li>In the top right corner, click the circle with your initials to access your JumpCloud account menu.</li>\n<li>Click <code>My API Key</code>. This will open a API Key modal.</li>\n<li>Click <code>Generate New API Key</code>. This will generate a new API Key and display it in the modal.</li>\n<li>Reveal the API Key by clicking the <code>eye</code> icon and copy or Click on the Copy icon to copy the API Key to your clipboard.</li>\n</ol>\n<p>Activate JumpCloud with Trustero:</p>\n<ol>\n<li>Fill in a <code>Nickname</code> and paste the API Key into the <code>API Key</code> field</li>\n<li>Click <code>Activate</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs190", "trs191"],
control_ids: ["IAM05", "AM04", "SC03", "AM06", "SC05"],
logo: logos.JumpCloud,
category: "Mobile Device Management",
type: 0,
field_template: [
    {
        "display": "API Key",
        "placeholder": "API Key",
        "field": "api_key",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-knowbe4",
name: "KnowBe4 Receptor",
content: "<p>Trustero will scan users and training information from your KnowBe4 account. In order to use KnowBe4, you must provide KnowBe4 API Key. Follow these steps to create an API Key.</p>\n<ol>\n<li>Login to KnowBe4 account as admin.</li>\n<li>Go to  <strong>Account Settings</strong>.</li>\n<li>Click the <strong>Account Integrations</strong> from the left menu.</li>\n<li>Click the <strong>API</strong> option.</li>\n<li>Mark the <strong>Enable Reporting API Access</strong> checkbox.</li>\n<li>Click on <strong>Reporting API</strong> link.</li>\n<li>Click on <strong>Create New API Token</strong> button.</li>\n<li>The system generates an API Key. Save this API Key.</li>\n<li>Enter a Nickname and the API Key copied from step 7, in the section below.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs192", "trs193"],
control_ids: ["HR06", "IAM05"],
logo: logos.KnowBe4,
category: "Security Awareness Training",
type: 0,
field_template: [
    {
        "display": "API Key",
        "placeholder": "API Key",
        "field": "api_key",
        "input_type": "password"
    },
    {
        "display": "Region",
        "placeholder": "Region",
        "field": "country_code",
        "input_type": "select",
        "options": [
            {
                "name": "United States",
                "value": "us"
            },
            {
                "name": "Canada",
                "value": "ca"
            },
            {
                "name": "United Kingdom",
                "value": "uk"
            },
            {
                "name": "Germany",
                "value": "de"
            },
            {
                "name": "Europe",
                "value": "eu"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-jira",
name: "Jira",
content: "<p>The Jira receptor allows you to attach Jira issues as evidence to controls you select. The issues are determined by Jira filters. Create filters in Jira to select the issues that are relevant to your controls and then map the filters to the controls.  <br />\nFor more information on how to use filters please see <a href=\"https://support.trustero.com/knowledge/jira-receptor\" target=\"_blank\" rel=\"noopener noreferrer\">instructions here</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Jira receptor.</li>\n<li>Press <code>Activate</code> and you will be redirected to Jira.</li>\n<li>If you have multiple sites in your account, select the correct site.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs197", "trs198"],
control_ids: [""],
logo: logos.Jira,
category: "Issue Tracking",
type: 0,
config_template: [
    {
        "title": "Control To Filter Mappings",
        "description": "Add mappings between Jira filters and the controls in your account.",
        "fields": [
            {
                "display": "Filter",
                "placeholder": "Filter",
                "input_type": "control_mapping",
                "field": "filters",
                "evidence_caption": "Jira Issues",
                "service_model_id": "trs197"
            }
        ]
    },
    {
        "title": "Control To Label Mappings",
        "description": "Add mappings between Jira labels and the controls in your account.",
        "fields": [
            {
                "display": "Label",
                "placeholder": "Label",
                "input_type": "control_mapping",
                "field": "labels",
                "evidence_caption": "Jira Issues",
                "service_model_id": "trs197"
            }
        ]
    }
],
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-gdrive",
name: "Google Drive",
content: "<p>Trustero's Google Drive integration allows you to link files in our platform. To grant Trustero access, please follow the <a href=\"https://support.trustero.com/knowledge/enable-google-drive-integration\" target=\"_blank\" rel=\"noopener noreferrer\">instructions</a>.</p>",
iscredvalid: false,
service_ids: [],
control_ids: [""],
logo: logos.GoogleDrive,
category: "File Storage",
type: 1,
field_template: [
    {
        "display": "Service Account Email",
        "placeholder": "Email",
        "field": "service_account_email"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-anecdotes",
name: "Anecdotes",
content: "<p>In order to use <code>Anecdotes</code>, you must provide <code>Anecdotes</code> API credentials.  <br />\nTo register your <code>Anecdotes</code> with Trustero, follow these steps:</p>\n<ol>\n<li>Login into <code>Anecdotes</code> as an Admin user</li>\n<li>Navigate to the <code>Access Manager</code></li>\n<li>Click on the <code>API</code> tab</li>\n<li>Click on the <code>Create new token</code> button</li>\n<li>Enter a name for the token</li>\n<li>Set <code>Expiration date</code> for the token - preferrrably 1 year from the current date</li>\n<li>Select <code>Admin</code> as the <code>Role</code> for the token</li>\n<li>Click on the <code>Create</code> button</li>\n<li>Copy the generated token and save it in a secure location</li>\n<li>Close the form and paste the <code>token</code> below in the <code>API Key</code> section and click <code>Activate</code></li>\n</ol>",
iscredvalid: false,
service_ids: [],
control_ids: [""],
logo: logos.Anecdotes,
category: "GRC",
type: 2,
field_template: [
    {
        "display": "Api Key",
        "placeholder": "Api Key",
        "field": "ApiKey",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-slack",
name: "Slack Receptor",
content: "<p>The Slack receptor allows you to attach Slack Messages as evidence to controls you select.</p>\n<p>The allowable slack workspace is determined by the Slack Application permitted into the workspace.</p>\n<p>For more information on how to create a Slack Application please see <a href=\"https://support.trustero.com/knowledge/slack-receptor-instructions\" target=\"_blank\" rel=\"noopener noreferrer\">instructions here</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Slack receptor</li>\n<li>Go to the Slack Application Screen</li>\n<li>Under the Oauth &amp; Permissions, copy the <code>Bot User Oauth Token</code></li>\n<li>Switch back to the trustero screen, and insert the <code>Bot User Oauth Token</code></li>\n<li>Click <code>Accept</code></li>\n</ol>\n<p><strong>Note:</strong> By default, the receptor processes the most recent 500 messages</p>",
iscredvalid: false,
service_ids: ["trs204", "trs205"],
control_ids: [""],
logo: logos.Slack,
category: "Collaboration Tool",
type: 0,
field_template: [
    {
        "display": "Oauth Token",
        "placeholder": "Oauth Token",
        "field": "Token",
        "input_type": "password"
    }
],
config_template: [
    {
        "title": "Control To Channel Mappings",
        "description": "Add mappings between Slack Channel and the controls in your account.",
        "fields": [
            {
                "display": "Channel",
                "placeholder": "Channel",
                "input_type": "control_mapping",
                "field": "channels",
                "evidence_caption": "Slack Messages",
                "service_model_id": "trs205"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-freshdesk",
name: "Freshdesk",
content: "<p>The Freshdesk receptor allows you to attach Freshdesk Tickets, Agents and SLA as evidence to controls you select.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Freshdesk receptor</li>\n<li>Go to the Freshdesk Application</li>\n<li>From the URL, obtain the <code>Domain</code> e.g. <code>https://{domain}.freshdesk.com</code></li>\n<li>Click your user icon on the top right of the screen</li>\n<li>Select <code>Profile Settings</code></li>\n<li>Obtain your <code>API Key</code> by clicking the <code>View API Key</code> button on the top right of the page</li>\n<li>Switch back to the trustero screen, and insert the <code>Domain</code> and <code>API Token</code></li>\n<li>Click <code>Accept</code></li>\n</ol>",
iscredvalid: false,
service_ids: ["trs210", "trs211"],
control_ids: [""],
logo: logos.Freshdesk,
category: "Customer Support Management",
type: 0,
field_template: [
    {
        "display": "Domain",
        "placeholder": "Domain",
        "field": "Domain"
    },
    {
        "display": "API Token",
        "placeholder": "API Token",
        "field": "Token",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-sonarqubecloud",
name: "SonarQube Cloud Receptor",
content: "<p>To use your SonarQube Cloud with Trustero, follow these steps:</p>\n<ol>\n<li>Log in to your SonarQube Cloud account.</li>\n<li>Navigate to the <code>My Account</code> section by clicking on your profile avatar in the top right corner.</li>\n<li>Select <code>Security</code> from the left-hand menu.</li>\n<li>Under the <code>Generate Tokens</code> section, click on the <code>Generate Token</code> button.</li>\n<li>Copy the generated token and paste the token in the Token field.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs209"],
control_ids: [""],
logo: logos.SonarQubeCloud,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "Token",
        "placeholder": "Token",
        "field": "Token",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-jsm",
name: "Jira Service Management",
content: "<p>The Jira Service Management receptor allows you to attach Jira Service Management issues and customer requests as evidence to controls you select. The issues are determined by Jira Service Management Queues. Create Queues in Jira Service Management to select the issues that are relevant to your controls and then map the queues to the controls.  <br />\nFor more information on how to use filters please see <a href=\"https://support.trustero.com/knowledge/jira-service-management-receptor\" target=\"_blank\" rel=\"noopener noreferrer\">instructions here</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Jira Service Management receptor.</li>\n<li>Press <code>Activate</code> and you will be redirected to Jira.</li>\n<li>If you have multiple sites in your account, select the correct site.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs216", "trs217", "trs218"],
control_ids: [""],
logo: logos.JiraServiceManagement,
category: "Customer Support Management",
type: 0,
config_template: [
    {
        "title": "Control To Queue Mappings",
        "description": "Add mappings between Jira Service Management Queue and the controls in your account.",
        "fields": [
            {
                "display": "Queue",
                "placeholder": "Queue",
                "input_type": "control_mapping",
                "field": "queues",
                "evidence_caption": "Jira Service Management Issues",
                "service_model_id": "trs216"
            }
        ]
    }
],
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-confluence",
name: "Confluence",
content: "<p>The Confluence receptor allows you to attach Confluence pages as evidence to selected controls using either a URL or labels. The pages are determined by the Confluence URL or labels.</p>\n<ul>\n<li>For single-page evidence, map the evidence using the page URL to the controls.</li>\n<li>For multiple-page evidence, map the pages using labels in Confluence to the controls.</li>\n</ul>\n<p>For more information on using labels, please refer to the instructions <a href=\"https://support.trustero.com/knowledge/confluence-receptor\" target=\"_blank\" rel=\"noopener noreferrer\">here</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Confluence receptor.</li>\n<li>Press <code>Activate</code> and you will be redirected to Confluence.</li>\n<li>If you have multiple sites in your account, select the correct site.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs219", "trs220"],
control_ids: [""],
logo: logos.Confluence,
category: "Internal Wiki",
type: 0,
config_template: [
    {
        "title": "Control To Page URL Mappings",
        "description": "Add mappings between Confluence Page URLs and the controls in your account.",
        "fields": [
            {
                "display": "Page URL",
                "placeholder": "Page URL",
                "input_type": "manual_control_mapping",
                "field": "urls",
                "evidence_caption": "Confluence Page",
                "service_model_id": "trs220"
            }
        ]
    },
    {
        "title": "Control To Page Label Mappings",
        "description": "Add mappings between Confluence Page Labels and the controls in your account.",
        "fields": [
            {
                "display": "Page Label",
                "placeholder": "Page Label",
                "input_type": "stacked_mapping",
                "field": "stacked_mappings",
                "evidence_caption": "Confluence Pages",
                "service_model_id": "trs220"
            }
        ]
    }
],
methods: [
    {
        "display": "OAuth",
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-zendesk",
name: "Zendesk Receptor",
content: "<p>The Zendesk receptor allows you to attach Zendesk Tickets as evidence to controls.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Zendesk receptor.</li>\n<li>Enter your <code>Account Name</code>.</li>\n<li>Press <code>Activate</code> and you will be redirected to Zendesk.</li>\n<li>Click on the <code>Accept</code> button.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs212", "trs213"],
control_ids: [""],
logo: logos.Zendesk,
category: "Customer Support Management",
type: 0,
field_template: [
    {
        "display": "Account Name",
        "placeholder": "account",
        "field": "Account"
    }
],
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-hubspot",
name: "Hubspot Receptor",
content: "<p>The Hubspot receptor allows you to attach Hubspot Tickets as evidence to controls.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Hubspot receptor.</li>\n<li>Press <code>Activate</code> and you will be redirected to Hubspot.</li>\n<li>Click on the <code>Accept</code> button.<br />\nNote: Ensure that the user has the necessary permissions to view CRM Tickets and access the User Table.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs221", "trs222"],
control_ids: [""],
logo: logos.HubSpot,
category: "Customer Support Management",
type: 0,
methods: [
    {
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-okta",
name: "Okta Receptor",
content: "<p>The Okta receptor allows you to attach Okta IAM users, logs, and policies as evidence to controls.</p>\n<p>To enable the receptor, follow these steps:</p>\n<ol>\n<li>Log in to your Okta admin account (e.g., <code>https://orgurl-admin.okta.com</code>).</li>\n<li>Navigate to <code>Security</code> &gt; <code>API</code> in the left navigation menu.</li>\n<li>Go to the <code>Tokens</code> tab.</li>\n<li>Click the <code>Create Token</code> button.</li>\n<li>Save the generated token.</li>\n<li>Click on your user profile in the upper right corner.</li>\n<li>Copy the Organization URL.</li>\n<li>In Trustero, enter the <code>API Token</code> and <code>Organization URL</code> in the respective fields.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs223", "trs224"],
control_ids: [""],
logo: logos.Okta,
category: "Identity and Access Management",
type: 0,
field_template: [
    {
        "display": "API Token",
        "placeholder": "API Token",
        "field": "Token",
        "input_type": "password"
    },
    {
        "display": "Organization Url",
        "placeholder": "Organization Url",
        "field": "OrgUrl"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-azuredevops",
name: "Azure DevOps Boards",
content: "<p>The Azure DevOps Boards receptor allows you to attach DevOps Work Items as evidence to controls you select. The Work Items are determined by Azure DevOps Queries. Create Queries in Azure DevOps Boards to select the Work Items that are relevant to your controls and then map the queries to the controls.</p>\n<p>For more information on how to use filters please see <a href=\"https://support.trustero.com/knowledge/azure-devops-boards-receptor\" target=\"_blank\" rel=\"noopener noreferrer\">instructions</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Azure DevOps Boards receptor.</li>\n<li>Go to the User Settings, Personal Access Token in Azure DevOps</li>\n<li>Create, grant permission, and copy the <code>Personal Access Token (PAT)</code></li>\n<li>Switch back to the Trustero screen, and insert the <code>Personal Access Token (PAT)</code></li>\n<li>Click <code>Accept</code></li>\n</ol>",
iscredvalid: false,
service_ids: ["trs225", "trs226"],
control_ids: [""],
logo: logos.AzureDevOpsBoards,
category: "Issue Tracking",
type: 0,
field_template: [
    {
        "display": "Organization",
        "placeholder": "Organization",
        "field": "Organization"
    },
    {
        "display": "Personal Access Token",
        "placeholder": "Personal Access Token",
        "field": "Token",
        "input_type": "password"
    }
],
config_template: [
    {
        "title": "Control To Query Mappings",
        "description": "Add mappings between Azure Devops Boards Query and the controls in your account.",
        "fields": [
            {
                "display": "Query",
                "placeholder": "Query",
                "input_type": "control_mapping",
                "field": "queries",
                "evidence_caption": "Azure Devops Boards Work Items",
                "service_model_id": "trs226"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-rippling",
name: "Rippling Receptor",
content: "<p>The Rippling receptor allows you to attach Rippling Employees and Orgchart as evidence to controls you select.</p>\n<p>The allowable Rippling workspace is determined by the API Key authorized for the Rippling Receptor.</p>\n<p>For more information on how to create a Rippling API Key, please see <a href=\"https://help.rippling.com/s/article/4403858209431\" target=\"_blank\" rel=\"noopener noreferrer\">this help article</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Rippling receptor</li>\n<li>Go to your Rippling Admin Portal</li>\n<li>Navigate to the API Key Management section</li>\n<li>Generate or retrieve your API Key</li>\n<li>Switch back to the Trustero configuration screen and paste the API Key</li>\n<li>Click <code>Accept</code></li>\n</ol>\n<p><strong>Note:</strong> The receptor fetches employee and org structure data based on your permissions.<br />\n<strong>Note:</strong> By default, orgcharts are limited to 1000 employees.</p>",
iscredvalid: false,
service_ids: ["trs227", "trs228"],
control_ids: ["IAM01", "HR01"],
logo: logos.Rippling,
category: "Human Resources Information System",
type: 0,
field_template: [
    {
        "display": "Access Token",
        "placeholder": "Access Token",
        "field": "Token",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-archer",
name: "Archer",
content: "<p>Archer receptor</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Archer receptor.</li>\n<li>Fill <code>Url</code>. ex. If your Archer instance is <code>https://trustero.archerirm.us</code>, fill <code>https://trustero.archerirm.us</code>.</li>\n<li>Fill <code>Username</code>, <code>Password</code> and <code>InstanceName</code> fields.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs2000", "trs2001"],
control_ids: [""],
logo: logos.Archer,
category: "GRC",
type: 2,
field_template: [
    {
        "display": "Instance Url",
        "placeholder": "instance url",
        "field": "BaseUrl"
    },
    {
        "display": "Username",
        "placeholder": "username",
        "field": "Username"
    },
    {
        "display": "Password",
        "placeholder": "password",
        "field": "Password",
        "input_type": "password"
    },
    {
        "display": "InstanceName",
        "placeholder": "instancename",
        "field": "InstanceName"
    }
],
config_template: [
    {
        "title": "Control Set Filter",
        "description": "This may or may not be applicable in your case.",
        "fields": [
            {
                "display": "Select Control source",
                "placeholder": "Control Sources Filter",
                "input_type": "list_config",
                "field": "control_sources",
                "evidence_caption": "Archer Control Sources",
                "service_model_id": "trs197"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-jit",
name: "Jit Receptor",
content: "<p>The Jit receptor allows you to Jit Findings as scan report evidence and vulnerabilities evidence.</p>\n<p>For more information on how to create a Jit Client ID and Client Secret Key, please see <a href=\"https://docs.jit.io/docs/managing-users#generating-api-tokens\" target=\"_blank\" rel=\"noopener noreferrer\">this help article</a>.</p>\n<p>To enable the receptor please follow the steps below:</p>\n<ol>\n<li>Choose a nickname for your Jit receptor</li>\n<li>Go to your Jit User Accout</li>\n<li>Navigate to Settings &gt; Users and Permissons in the left Nav Bar</li>\n<li>Under API Tokens, Generate or retrieve your Client ID and Client Secret</li>\n<li>Switch back to the Trustero configuration screen and paste the API Key</li>\n<li>Click <code>Accept</code></li>\n</ol>",
iscredvalid: false,
service_ids: ["trs229", "trs230"],
control_ids: ["SD01", "IAM05"],
logo: logos.Jit,
category: "Source Code Service",
type: 0,
field_template: [
    {
        "display": "Client ID",
        "placeholder": "Client ID",
        "field": "ClientID"
    },
    {
        "display": "Client Secret",
        "placeholder": "Client Secret",
        "field": "ClientSecret",
        "input_type": "password"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-sharepoint",
name: "SharePoint",
content: "<p>The <code>SharePoint</code> document management system allows you to attach document library metadata as evidence to compliance controls within Trustero. It connects to your SharePoint environment to retrieve document structure, file presence, and associated metadata from configured sites and document libraries.</p>\n<p>Register the application within Azure using the <a href=\"https://support.trustero.com/knowledge/microsoft-app-registration-setup-guide\" target=\"_blank\" rel=\"noopener noreferrer\">App Registration instructions</a>. Then, configure the SharePoint-specific permissions and access scopes using the <a href=\"https://support.trustero.com/knowledge/sharepoint-document-management-system-setup-guide\" target=\"_blank\" rel=\"noopener noreferrer\">SharePoint Document Management System Setup Guide</a>.</p>\n<h2 id=\"to-enable-the-system-integration-follow-the-steps-below\">To enable the system integration, follow the steps below:</h2>\n<ol>\n<li>Choose a nickname for your <code>SharePoint</code> system in the Trustero configuration screen.  </li>\n<li>Locate the following values from your Azure App Registration:  <ul>\n<li><code>Client ID</code> - <code>App registrations &gt; [Your App] &gt; Overview &gt; Application (client) ID</code>  </li>\n<li><code>Client Secret</code> - <code>App registrations &gt; [Your App] &gt; Manage &gt; Certificates &amp; secrets</code>  </li>\n<li><code>Tenant ID</code> -   <code>App registrations &gt; [Your App] &gt; Overview &gt; Directory (tenant) ID</code>  </li></ul></li>\n<li>Switch back to the Trustero configuration screen and enter the <code>Client ID</code>, <code>Secret</code>, and <code>Tenant ID</code> into their respective fields.  </li>\n<li>Enter your <code>Base URL</code>. This is the Base URL of your SharePoint instance.  </li>\n<li>Click <code>Accept</code> to activate the system integration.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs3001"],
control_ids: [""],
logo: logos.SharePoint,
category: "File Storage",
type: 1,
field_template: [
    {
        "display": "Client ID",
        "placeholder": "clientId",
        "field": "ClientId"
    },
    {
        "display": "Client Secret",
        "placeholder": "clientSecret",
        "field": "ClientSecret",
        "input_type": "password"
    },
    {
        "display": "Tenant ID",
        "placeholder": "tenantId",
        "field": "TenantId"
    },
    {
        "display": "Base Url",
        "placeholder": "https://<tenant>.sharepoint.com/",
        "field": "BaseUrl"
    }
],
config_template: [
    {
        "title": "Sharepoint File Mappings",
        "description": "Add mappings between Sharepoint Files to policy documents or evidences",
        "fields": [
            {
                "display": "File URL",
                "placeholder": "File URL",
                "input_type": "manual_control_mapping",
                "field": "urls",
                "evidence_caption": "Sharepoint File",
                "service_model_id": "trs3001"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-jira-workflow",
name: "Jira Workflow",
content: "<p>Jira Workflow integration allows you to connect evidence-gathering workflows in Jira directly with Trustero, reducing manual effort and enabling smoother collaboration between systems.</p>\n<p>For more information on how to use set up and use Trustero's Jira Workflow integration please see instructions<a href=\"https://support.trustero.com/knowledge/jira-workflow-management-integration\">here</a>.</p>\n<p>To enable the integration please follow the steps below.</p>\n<ol>\n<li>Enter the url for your jira site.</li>\n<li>Enter the label where the integration can find the tasks.</li>\n<li>Press <code>Activate</code> and you will be redirected to Jira.</li>\n<li>If you have multiple sites in your account, select the correct site.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs4001", "trs4002"],
control_ids: [""],
logo: logos.Jira,
category: "Workflow Management",
type: 3,
field_template: [
    {
        "display": "Jira Site URL",
        "placeholder": "example.atlassian.net",
        "field": "Site",
        "method": "oauth"
    },
    {
        "display": "Jira Label",
        "placeholder": "sample-ticket-label",
        "field": "Label",
        "method": "oauth"
    }
],
config_template: [
    {
        "title": "Project Mappings",
        "description": "Select projects and corresponding issue types",
        "fields": [
            {
                "display": "Project",
                "placeholder": "Project",
                "input_type": "project_mapping",
                "field": "project_mappings",
                "evidence_caption": "Projects",
                "service_model_id": "trs4001"
            }
        ]
    },
    {
        "title": "Other Config",
        "description": "Configure the Report Request",
        "fields": [
            {
                "display": "Config",
                "placeholder": "Config",
                "input_type": "json",
                "field": "configs",
                "evidence_caption": "Config",
                "service_model_id": "trs4001"
            }
        ]
    }
],
methods: [
    {
        "display": "OAuth",
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-servicenow-workflow",
name: "ServiceNow Workflow",
content: "<p>ServiceNow Workflow integration allows you to connect evidence-gathering workflows in ServiceNow directly with Trustero, reducing manual effort and enabling smoother collaboration between systems.</p>\n<p>For more information on how to set up and use Trustero's ServiceNow Workflow integration, please see these<a href=\"https://support.trustero.com/knowledge/servicenow-workflow-management-user-guide\">instructions</a>.</p>\n<p>We recommend creating a dedicated service account for the integration. For more details, please see these<a href=\"https://support.trustero.com/knowledge/servicenow-workflow-management-creating-a-service-user\">instructions</a>.</p>\n<p>To enable the integration, please follow the steps below.</p>\n<ol>\n<li>Enter the URL for your ServiceNow instance.</li>\n<li>Enter your OAuth App ClientId.</li>\n<li>Enter your OAuth App ClientSecret.</li>\n<li>Enter the Service Account Username.</li>\n<li>Enter the Service Account Password.</li>\n<li>Enter the Label where the integration can find the tasks.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: ["- trs4003"],
control_ids: [""],
logo: logos.ServiceNow,
category: "Workflow Management",
type: 3,
field_template: [
    {
        "display": "ServiceNow Instance",
        "placeholder": "example.service-now.com",
        "field": "Site"
    },
    {
        "display": "OAuth App ClientId",
        "placeholder": "client_id",
        "field": "ClientID"
    },
    {
        "display": "OAuth App ClientSecret",
        "placeholder": "client_secret",
        "field": "ClientSecret",
        "input_type": "password"
    },
    {
        "display": "Service Account Username",
        "placeholder": "svc.user",
        "field": "ServiceAccountUsername"
    },
    {
        "display": "Service Account Password",
        "placeholder": "********",
        "field": "ServiceAccountPassword",
        "input_type": "password"
    },
    {
        "display": "Label",
        "placeholder": "sample-ticket-label",
        "field": "Label"
    }
],
config_template: [
    {
        "title": "Application Mappings",
        "description": "Select applications and corresponding issue types",
        "fields": [
            {
                "display": "Application",
                "placeholder": "Application",
                "input_type": "project_mapping",
                "field": "project_mappings",
                "evidence_caption": "Projects",
                "service_model_id": "trs4003"
            }
        ]
    },
    {
        "title": "Advanced Mappings",
        "description": "Configure field mappings for ServiceNow",
        "fields": [
            {
                "display": "Advance Mapping",
                "placeholder": "Advance Mapping",
                "input_type": "advance_mapping",
                "field": "advance_mappings",
                "evidence_caption": "Advance Mapping",
                "service_model_id": "trs4003"
            }
        ]
    },
    {
        "title": "Other Config",
        "description": "Upstream config for report calls",
        "fields": [
            {
                "display": "Config",
                "placeholder": "Config",
                "input_type": "json",
                "field": "configs",
                "evidence_caption": "Config",
                "service_model_id": "trs4003"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-docebo",
name: "Docebo",
content: "<h1 id=\"docebo-receptor\">Docebo Receptor</h1>\n<p>The Docebo receptor allows you to integrate Docebo LMS (Learning Management System) with Trustero for evidence collection and reporting.</p>\n<p>For more information on how to create a Docebo Client ID, Client Secret, Super Admin Username, and Super Admin Password, please see<a href=\"https://www.docebo.com/knowledge-base/\">this help article</a>.</p>\n<p>To enable the receptor, please follow the steps below:</p>\n<ol>\n<li>Choose a nickname for your Docebo receptor.</li>\n<li>Log in to your Docebo Admin account.</li>\n<li>Navigate to the \"API and SSO\" section in the Admin Menu.</li>\n<li>Under \"API Credentials,\" generate or retrieve your Client ID and Client Secret.</li>\n<li>Ensure you have the Super Admin Username and Super Admin Password for your Docebo account.</li>\n<li>Switch back to the Trustero configuration screen and paste the Client ID, Client Secret, Super Admin Username, and Super Admin Password.</li>\n<li>Enter the Sub Domain. Ex. If <code>acme.docebosaas.com</code> is your instance url, enter <code>acme</code> here.  </li>\n<li>Click <code>Accept</code> to complete the setup.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs235", "trs236", "trs237"],
control_ids: ["trc4014", "IAM05", "trc4015", "IAM06", "trc4016", "IAM04", "trc4017", "IAM01", "trc4018", "IAM03", "trc4019", "IAM02", "trc4057", "HR06", "trc4078", "SD02"],
logo: logos.Docebo,
category: "Security Awareness Training",
type: 0,
field_template: [
    {
        "display": "Client ID",
        "placeholder": "Client ID",
        "field": "ClientID"
    },
    {
        "display": "Client Secret",
        "placeholder": "Client Secret",
        "field": "ClientSecret",
        "input_type": "password"
    },
    {
        "display": "Super Admin Username",
        "placeholder": "Super Admin Username",
        "field": "SuperAdminUserName"
    },
    {
        "display": "Super Admin Password",
        "placeholder": "Super Admin Password",
        "field": "SuperAdminPassword",
        "input_type": "password"
    },
    {
        "display": "Subdomain",
        "placeholder": "Subdomain",
        "field": "Subdomain"
    }
],
config_template: [
    {
        "title": "Control To Report Mappings",
        "description": "Add mappings between Docebo reports and the controls in your account.",
        "fields": [
            {
                "display": "Reports",
                "placeholder": "Reports",
                "input_type": "control_mapping",
                "field": "reports",
                "evidence_caption": "Docebo Reports",
                "service_model_id": "trs237"
            }
        ]
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-confluence-dms",
name: "Confluence",
content: "<p>The Confluence receptor allows you to attach Confluence pages as evidence to selected controls using either a URL or labels. The pages are determined by the Confluence URL or labels.</p>\n<ul>\n<li>For single-page evidence, map the evidence using the page URL to the controls.</li>\n<li>For multiple-page evidence, map the pages using labels in Confluence to the controls.</li>\n</ul>\n<p>For more information on using labels, please refer to the instructions <a href=\"https://support.trustero.com/knowledge/confluence-receptor\" target=\"_blank\" rel=\"noopener noreferrer\">here</a>.</p>\n<p>To enable the receptor please follow the steps below.</p>\n<ol>\n<li>Choose a nickname for your Confluence receptor.</li>\n<li>Press <code>Activate</code> and you will be redirected to Confluence.</li>\n<li>If you have multiple sites in your account, select the correct site.</li>\n<li>Click <code>Accept</code>.</li>\n</ol>",
iscredvalid: false,
service_ids: [],
control_ids: [""],
logo: logos.Confluence,
category: "Internal Wiki",
type: 1,
field_template: [
    {
        "display": "Jira Site URL",
        "placeholder": "example.atlassian.net",
        "field": "Site",
        "method": "oauth"
    }
],
config_template: [
    {
        "title": "Control To Page URL Mappings",
        "description": "Add mappings between Confluence Page URLs and the controls in your account.",
        "fields": [
            {
                "display": "Page URL",
                "placeholder": "Page URL",
                "input_type": "manual_control_mapping",
                "field": "urls",
                "evidence_caption": "Confluence Page",
                "service_model_id": "trs220"
            }
        ]
    },
    {
        "title": "Control To Page Label Mappings",
        "description": "Add mappings between Confluence Page Labels and the controls in your account.",
        "fields": [
            {
                "display": "Page Label",
                "placeholder": "Page Label",
                "input_type": "stacked_mapping",
                "field": "stacked_mappings",
                "evidence_caption": "Confluence Pages",
                "service_model_id": "trs220"
            }
        ]
    }
],
methods: [
    {
        "display": "OAuth",
        "value": "oauth"
    }
]
        },
        
        {
            ...new ReceptorRecord().toObject(),
modelid: "trr-salesforce",
name: "Salesforce Receptor",
content: "<p>The Salesforce receptor allows you to attach Salesforce cases as evidence to the controls you select.  <br />\nThe cases are grouped by <strong>topics</strong>, which serve the same purpose as labels in Salesforce.  <br />\nCreate and manage topics in Salesforce to categorize cases that are relevant to your controls, and then map those topics to the corresponding controls.</p>\n<p>For more information on configuring the Salesforce receptor, please see the instructions <a href=\"https://support.trustero.com/knowledge/salesforce-receptor\">here</a>.</p>\n<p>To enable the receptor, please follow the steps below:</p>\n<ol>\n<li>Choose a nickname for your Salesforce receptor.</li>\n<li>Provide the following information:<ul>\n<li><strong>Domain</strong>: The base URL of your Salesforce instance (e.g., <code>https://yourinstance.my.salesforce.com</code>)</li>\n<li><strong>Client ID</strong>: The connected app client ID from Salesforce.</li>\n<li><strong>Client Secret</strong>: The connected app client secret from Salesforce.</li></ul></li>\n<li>Press <strong>Activate</strong> to authorize and connect your Salesforce account.</li>\n<li>Once connected, the receptor will securely retrieve data using the credentials you provided.</li>\n</ol>",
iscredvalid: false,
service_ids: ["trs238", "trs239"],
control_ids: [""],
logo: logos.Salesforce,
category: "Customer Support Management",
type: 0,
field_template: [
    {
        "display": "Domain",
        "placeholder": "domain",
        "field": "Domain"
    },
    {
        "display": "Client ID",
        "placeholder": "clientid",
        "field": "ClientID"
    },
    {
        "display": "Client Secret",
        "placeholder": "clientsecret",
        "field": "ClientSecret",
        "input_type": "password"
    }
],
config_template: [
    {
        "title": "Control To Topic Mappings",
        "description": "Add mappings between Salesforce topics and the controls in your account.",
        "fields": [
            {
                "display": "Topic",
                "placeholder": "Topic",
                "input_type": "control_mapping",
                "field": "topics",
                "evidence_caption": "Salesforce Cases",
                "service_model_id": "trs239"
            }
        ]
    }
]
        },
        ]

export default DATA


export function getReceptorTemplate(modelId: string): Receptor {
  const matchedReceptor = DATA.find((r) => r.modelid === modelId)
  if (!matchedReceptor) {
    throw new Error('Reference to unknown receptor:' + modelId)
  }
  return matchedReceptor
}

export function getAllReceptorTemplates(): Receptor[] {
  return DATA
}

